import { render, staticRenderFns } from "./create-tenant.vue?vue&type=template&id=3b9dedd1&scoped=true&"
import script from "./create-tenant.vue?vue&type=script&lang=js&"
export * from "./create-tenant.vue?vue&type=script&lang=js&"
import style0 from "./create-tenant.vue?vue&type=style&index=0&id=3b9dedd1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9dedd1",
  null
  
)

export default component.exports